angular.module('dpw.components')

    .directive('dpwSaveStatus', [function () {
        return {
            restrict: 'A',
            scope: {},
            bindToController: true,
            controller: ['$scope', '$timeout', function ($scope, $timeout) {
                var self = this;
                self.isSaved = false;

                $scope.$on('dpwSaveStatus:showSavedStatus', function () {
                    showSavedStatus();
                });

                function showSavedStatus() {
                    self.isSaved = true;
                    self.promise && $timeout.cancel(self.promise);
                    self.promise = $timeout(function () {
                        self.isSaved = false;
                    }, 3000);
                }
            }],
            controllerAs: 'ctrl',
            templateUrl: 'dpw-save-status.html'
        };
    }])

;